import { Avatar, Heading, Text } from "@pamperedchef/design-system";
import type { HeadingTag } from "@/app/utilities/types";

import * as sharedStyles from "../shared.module.scss";
import * as styles from "./ConsultantDetails.module.scss";

export interface ConsultantDetailsProps {
	avatarImageUrl?: string;
	titleTag?: HeadingTag;
	consultantName?: string;
	location?: string;
	consultantTime?: string;
}

/**
 * ConsultantDetails component
 */
export function ConsultantDetails({
	avatarImageUrl,
	titleTag = "h4",
	consultantName,
	location,
	consultantTime
}: ConsultantDetailsProps): JSX.Element {
	return (
		<div className={styles["consultant-details"]}>
			<div className={styles["consultant-details__avatar"]}>
				<Avatar size="xlarge" src={avatarImageUrl} />
			</div>

			<div className={sharedStyles["details__content"]}>
				<div>
					{consultantName && (
						<Heading styledAs="h4" tag={titleTag}>
							{consultantName}
						</Heading>
					)}

					<Text
						styledAs="sml"
						className={sharedStyles["details__legend"]}
					>
						{location} {consultantTime}
					</Text>
				</div>
			</div>
		</div>
	);
}
